/**
 * Cloud auth client — connects to the Lovable Cloud Supabase project.
 * Used ONLY for authentication (sign in, sign up, OAuth) and edge functions.
 * All data operations (brands, accessories, feature_flags, etc.)
 * now use the external database client in untypedClient.ts.
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const CLOUD_URL = import.meta.env.VITE_SUPABASE_URL;
const CLOUD_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const cloudClient = createClient<Database>(CLOUD_URL, CLOUD_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
